import React, {memo, useState} from "react";

import debug from "../../../../Lib/debug"
import LinearProgress from "@material-ui/core/LinearProgress";
import {useSystemSettings} from "../../Api/system-settings";
import {baseTableStyles} from "../../../simplexion-table/baseStyle";
import {updatableCheckBoxStyle} from "../../../simplexion-table/templates/checkbox-input";
import {inputFieldStyles} from "../../../simplexion-table/templates/text-input";
import {customActions} from "../../../simplexion-table/templates/action-buttons";
import ContentBox from "../../../../Components/ContentBox/ContentBox";
import {FilterField} from "../../../../Components/Table/FilterField";
import {SimplexionTable} from "../../../simplexion-table/SimplexionTable";
import {makeTableStyles} from "../../../../Components/Table/tableStyles";
import {makeStyles} from "@material-ui/core";
import Section from "../../../form/Components/Section/Section";


const useTableStyles = makeStyles(makeTableStyles(baseTableStyles, updatableCheckBoxStyle, inputFieldStyles));

const List = memo((props) => {

    debug("RENDER", "useForm", () => [" -> List_Of_System_Settings", props]);

    const {path} = props;

    const {loadingStatus, data} = useSystemSettings();

    const urlNs = path[0].url + "/";

    const tableClasses = useTableStyles();

    const [state, setState] = useState('');

    const handleFilter = val => setState(val);

    const tableConfig = {
        id: 'system-settings-table',
        nameSpace: 'systemSettings',
        stickyHeader: true,
        sortable: true,
        styles: tableClasses,
        columns: [
            {
                accessor: 'id',
            },
            {
                accessor: 'name',
            },
            {
                accessor: 'value',
            },
            {
                accessor: 'action',
                renderer: (...args) => customActions(true, false, urlNs, ...args),
                sortable: false,
            },
        ],
    };

    return (
        <ContentBox path={path}>
            <Section>
                <FilterField handler={handleFilter}/>
                {loadingStatus > 0 ? <LinearProgress/> : null}
                <SimplexionTable tableConfig={tableConfig} data={data} loadingStatus={loadingStatus}
                                 filterValue={state}/>
            </Section>
        </ContentBox>
    );
});

export default List;